"use client";

import Link, { useLinkStatus } from "next/link";
import { LoaderCircle } from "lucide-react";
import type { ComponentProps } from "react";
import { createPortal } from "react-dom";
import { DashboardSkeleton, TablePageSkeleton } from "./loading-skeleton";

function NavigationFeedback({ dashboard }: { dashboard: boolean }) {
  const { pending } = useLinkStatus();
  return (
    <>
      {pending && (
        <>
          <span
            role="status"
            aria-label="กำลังโหลดหน้า"
            className="ml-1 inline-flex align-middle"
          >
            <LoaderCircle
              aria-hidden="true"
              size={13}
              className="animate-spin motion-reduce:animate-none"
            />
          </span>
          <span
            aria-hidden="true"
            className="fixed inset-x-0 top-0 z-50 h-0.5 animate-pulse bg-accent motion-reduce:animate-none"
          />
          {typeof document !== "undefined" &&
            document.getElementById("page-content") &&
            createPortal(
              <div
                data-navigation-skeleton
                className="absolute inset-0 z-30 min-h-screen bg-background p-4 sm:p-6 lg:p-8"
              >
                {dashboard ? <DashboardSkeleton /> : <TablePageSkeleton />}
              </div>,
              document.getElementById("page-content")!,
            )}
        </>
      )}
    </>
  );
}

export default function NavigationLink({
  children,
  ...props
}: ComponentProps<typeof Link>) {
  return (
    <Link {...props}>
      {children}
      <NavigationFeedback
        dashboard={
          (typeof props.href === "string"
            ? props.href.split("?")[0]
            : props.href.pathname) === "/"
        }
      />
    </Link>
  );
}
